import React from 'react'
import WalletReport from '../../Component/WalletTransfer/WalletReport/WalletReport'
const FxWalletReport = () => {
  return (
    <>
        <WalletReport/>
    </>
  )
}

export default FxWalletReport